'use strict';

angular.module('pulse')
  .filter('fullDate', ['$filter', function($filter) {
    return function(input) {
        return $filter('date')(input, 'EEEE, MMMM d, yyyy \'at\' h:mm:ss a');
    };
}]);
